interface ConfigsType {
  baseUrl: string;
  baseName: string;
  token: string;
}

const configs: ConfigsType = {
  //   baseUrl: 'http://api-ecatalog.devx.sweetsoft.org',
  //   baseName: '',
  baseUrl: '/catalog',
  baseName: '/catalog',
  token: '@token',
};

export default configs;
